import type { Components } from "@mui/material/styles";

export const MuiMenuItem: Components["MuiMenuItem"] = {
  styleOverrides: {
    root: {
      fontSize: "var(--font-size-m)",
    },
  },
};
